import { useQuery } from 'react-query';

import { DealStatusView, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDealStatusViewQuery(guid: Guid | undefined) {
	const api = useApi();

	return useQuery(
		QueryKeys.Deal.UpdateStatus(guid),
		() => AxiosUtils.getResponseData<DealStatusView>(api.get(CerebroApiEndpoints.Deals.DealStatus(guid))),
		{ enabled: guid !== undefined }
	);
}
